import React from 'react';
import PropTypes from 'prop-types';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import { TEXT_LABELS } from '../constants/TextLabelConstants';
import { FONTS } from '../constants/Fonts';

const HousieBackButton = ({ onClick, style = {}, showLabel = true }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        ...style,
      }}
    >
      {/* Figma back_Button — 30px circle, gradient ring, icon inset 16.67% */}
      <span
        style={{
          position: 'relative',
          width: 30,
          height: 30,
          borderRadius: 100,
          flexShrink: 0,
          background: 'linear-gradient(to top, #5A04D7, #FF00F2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
        }}
      >
        <img
          src={IMAGE_CONSTANTS.V2_REVAMPED_LOBBY_BACK_ARROW}
          alt="Back"
          style={{
            position: 'absolute',
            inset: '16.67%',
            width: '66.66%',
            height: '66.66%',
            objectFit: 'contain',
            display: 'block',
          }}
        />
      </span>
      {showLabel && (
        <span
          style={{
            fontFamily: FONTS.INTER_SEMIBOLD,
            fontWeight: 600,
            fontSize: 16,
            lineHeight: '24px',
            letterSpacing: 0.8,
            color: '#FFFFFF',
            textShadow: '0px 4px 4px rgba(17,5,37,0.1)',
            whiteSpace: 'nowrap',
          }}
        >
          {TEXT_LABELS.RAP_HOUSIE_BACK_TO_PREVIOUS}
        </span>
      )}
    </button>
  );
};

HousieBackButton.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  showLabel: PropTypes.bool,
};

export default HousieBackButton;
